import styled from 'styled-components';

export const NavigationContainer = styled.div`
  display: flex;
  align-items: center;
  background: #FFFFFF;
`;
